export default {
      id: "Pear-usage",
      viewBox: "0 0 23 30",
      url: __webpack_public_path__ + "icons.svg#Pear",
      toString: function () {
        return this.url;
      }
    }